import { useState, useEffect } from 'react';
import { Badge, IconButton, Box, Drawer, Stack, Typography, Divider, Paper, Card, CardContent, CardActions } from '@mui/material';
import { Notifications as NotificationsIcon, Close as CloseIcon, TaskAlt as TaskAltIcon, NotificationImportant as NoNotificationsIcon } from "@mui/icons-material";
import { GET_UNREAD_NOTIFICATION, GET_ALL_NOTIFICATION, UPDATE_NOTIFICATION_READ_STATUS } from '../../../URLs';
import { toast } from 'react-toastify';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { getLocalStorageItem } from '../../../localStorageUtils';
import jwt from 'jwt-decode';
import { formatDistanceToNow } from 'date-fns';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import apiClient from '../../../../axios';

export default function NotificationsPopover() {
    const [unreadCount, setUnreadCount] = useState(0);
    const [notifications, setNotifications] = useState();
    // console.log("notifications", notifications);
    const [openNotification, setOpenNotification] = useState(false);
    const [userId, setUserId] = useState();

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            decoded.extension_URN ? setUserId(decoded.extension_URN) : setUserId(decoded.emails?.[0])
        }
    }, [getLocalStorageItem('id_token')]);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpenNotification(open);
        if(open) {
            updateReadStatus();
        }
        else {
            getUnreadCount();
            getAllNotifications();
        }
    };

    const handleOpen = (event) => {
        setOpenNotification(true);
    };

    const handleClose = () => {
        setOpenNotification(false);
    };

    useEffect(() => {
        if (userId) {
            getUnreadCount();
            getAllNotifications();
        }
    }, [userId]);

    function getUnreadCount() {
        loaderService.showLoader()
        apiClient
            .post(GET_UNREAD_NOTIFICATION,
                {
                    "userId": userId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUnreadCount(response?.data?.count)
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    function getAllNotifications() {
        loaderService.showLoader()
        apiClient
            .post(GET_ALL_NOTIFICATION,
                {
                    "userId": userId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setNotifications(response?.data?.appNotifications)
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    function updateReadStatus() {
        loaderService.showLoader()
        apiClient
            .post(UPDATE_NOTIFICATION_READ_STATUS,
                {
                    "userId": userId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

       

    return (
        <>
            <IconButton color={openNotification ? 'primary' : 'default'} onClick={toggleDrawer(true)} sx={{ width: 40, height: 40 }}>
                <Badge badgeContent={unreadCount} color="error">
                    <NotificationsIcon color="action" />
                </Badge>
            </IconButton>
            <Drawer
                anchor="right"
                open={openNotification}
            // onClose={toggleDrawer(false)}
            >
                <Box
                    sx={{ width: 350, padding: "16px", bgcolor: '#F8F8F8', minHeight: "100%" }}
                    role="presentation"
                // onClick={toggleDrawer(false)}
                // onKeyDown={toggleDrawer(false)}
                >
                    <Stack direction="row" justifyContent="space-between">
                        <Typography variant="h6" gutterBottom>
                            Notifications
                        </Typography>
                        <IconButton onClick={toggleDrawer(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    {notifications?.length > 0 ? <><Divider sx={{ color: '#0096FF', bgColor: "#0096FF", fontSize: "13px", marginTop: "16px", marginBottom: "16px" }}>Unread</Divider>
                        {unreadCount ?
                            <>{notifications?.filter((filterItem) => filterItem.readStatus === false)?.map((item) => {
                                 return (
                                    <Card sx={{ minWidth: 275, marginTop: "2vh" }}>
                                        <CardContent>
                                            <Typography component="div" dangerouslySetInnerHTML={{__html: item.message}} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                {/* {stripHTMLTags(item.message)} */}
                                            </Typography>
                                        </CardContent>
                                        <CardActions sx={{ float: "right" }}>
                                            <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>
                                                -- {formatDistanceToNow(new Date(item?.createdOn), { addSuffix: true })}
                                            </Typography>
                                        </CardActions>
                                    </Card>
                                    // <Paper elevation={1} sx={{
                                    //     textAlign: 'center',
                                    //     minHeight: 40,
                                    //     display: "flex",
                                    //     lineHeight: '60px', alignItems: "center", justifyContent: "center"
                                    // }}>
                                    //     <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                    //         {item.message}
                                    //     </Typography>
                                    // </Paper>
                                )
                            })}</>
                            : <Stack style={{ justifyContent: 'center', alignItems: 'center' }}>
                                <IconButton color="success" size="large" sx={{ display: "flex", alignItems: "center" }}>
                                    <TaskAltIcon fontSize="large" />
                                </IconButton>
                                <Typography variant="subtitle2" textAlign="center" gutterBottom>
                                    You're all caught up!
                                </Typography>
                                <Typography sx={{ fontSize: 14 }} textAlign="center" color="text.secondary" gutterBottom>
                                    You've seen all the new notifications
                                </Typography>
                            </Stack>
                        }
                        <Divider sx={{ color: '#0096FF', bgColor: "#0096FF", fontSize: "13px", marginTop: "4px", marginBottom: "16px" }}>Read</Divider>
                        {notifications?.filter((filterItem) => filterItem.readStatus === true)?.length > 0 ? notifications?.filter((filterItem) => filterItem.readStatus === true)?.slice(0, 5)?.map((item) => {
                            return (
                                <Card sx={{ minWidth: 275, marginTop: "2vh" }}>
                                    <CardContent>
                                        <Typography component="div" dangerouslySetInnerHTML={{__html: item.message}} sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                            {/* {stripHTMLTags(item.message)} */}
                                        </Typography>
                                    </CardContent>
                                    <CardActions sx={{ float: "right" }}>
                                        <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>
                                            -- {formatDistanceToNow(new Date(item?.createdOn), { addSuffix: true })}
                                        </Typography>
                                    </CardActions>
                                </Card>
                                // <Paper elevation={1} sx={{
                                //     textAlign: 'center',
                                //     minHeight: 40,
                                //     display: "flex",
                                //     lineHeight: '60px', alignItems: "center", justifyContent: "center"
                                // }}>
                                //     <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                //         {item.message}
                                //     </Typography>
                                // </Paper>
                            )
                        }) : <Stack style={{ justifyContent: 'center', alignItems: 'center' }} mt={10}>
                            <IconButton size="large" sx={{ display: "flex", alignItems: "center" }}>
                                <NoNotificationsIcon fontSize="large" />
                            </IconButton>
                            <Typography variant="subtitle2" textAlign="center" gutterBottom>
                                No old notifications!
                            </Typography>
                        </Stack>}

                    </> : <Stack style={{ justifyContent: 'center', alignItems: 'center' }} mt={10}>
                        <IconButton size="large" sx={{ display: "flex", alignItems: "center" }}>
                            <NoNotificationsIcon fontSize="large" />
                        </IconButton>
                        <Typography variant="subtitle2" textAlign="center" gutterBottom>
                            No Notifications yet!
                        </Typography>
                    </Stack>}
                </Box>
            </Drawer></>
    )
}